// extracted by mini-css-extract-plugin
export default {"message_text":"StateOfTransport_message_text__q7THw"};